import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAboutAsync } from "../../features/cmsSlice";
const About = () => {
    const dispatch = useDispatch();
    const aboutData = useSelector((state) => state.cms.aboutData);
    console.log(aboutData);
    const scroll = useRef(null);
    useEffect(() => {
        dispatch(GetAboutAsync());
        scroll.current?.scrollIntoView({ behavior: "smooth" });
    }, []);

    return (
        <section className="about-us-main" ref={scroll}>
            <div className="container">
                <div className="row position-relative align-items-center">
                    <img
                        src="assets/images/about/path-pink.svg"
                        alt="path-pink"
                    />
                    <div className="col-lg-6">
                        <div className="about-main-img-wrap">
                            <img src={aboutData[0]?.image} alt="" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-us-content">
                            <h3>{aboutData[0]?.title}</h3>

                            <p
                                className="bg-red-text"
                                dangerouslySetInnerHTML={{
                                    __html: aboutData[0]?.detail,
                                }}
                            ></p>
                        </div>
                    </div>
                </div>
                <div className="row position-relative align-items-center">
                    <img
                        src="assets/images/about/path-blue.svg"
                        alt="path-pink"
                    />
                    <div className="col-lg-6">
                        <div className="about-us-content">
                            <h3>{aboutData[1]?.title}</h3>

                            <p
                                className="bg-red-text"
                                dangerouslySetInnerHTML={{
                                    __html: aboutData[1]?.detail,
                                }}
                            ></p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-main-img-wrap">
                            <img src={aboutData[1]?.image} alt="" />
                        </div>
                    </div>
                </div>
                <div className="row position-relative align-items-center">
                    <img
                        src="assets/images/about/path-pink.svg"
                        alt="path-pink"
                    />
                    <div className="col-lg-6">
                        <div className="about-main-img-wrap">
                            <img src={aboutData[2]?.image} alt="" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-us-content">
                            <h3>{aboutData[2]?.title}</h3>

                            <p
                                className="bg-red-text"
                                dangerouslySetInnerHTML={{
                                    __html: aboutData[2]?.detail,
                                }}
                            ></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
